import styled from "styled-components";
import { List as MuiList } from "@material-ui/core";

const List = styled(MuiList)`
    padding: 0px;
`;

export default List;
